import { render, staticRenderFns } from "./LotteryConfig.vue?vue&type=template&id=9f8368ec&"
import script from "./LotteryConfig.vue?vue&type=script&lang=js&"
export * from "./LotteryConfig.vue?vue&type=script&lang=js&"
import style0 from "./LotteryConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports